﻿import React, { useEffect, useState, useLocation, useContext, useLayoutEffect } from "react";
import { Container, Col, Row, Tab, Tabs } from "react-bootstrap";
import "./CompanyKeystat.css";
import URLstateContext from "../../../provider/CommonContext";
import {  useParams } from "react-router-dom";
function CompanyKeystat(props, ref) {
    let getCoCode = props.coCode;
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [type, settype] = useState(['C']);
    const [dataCompanyName, setdataCompanyName] = useState([]);
    const [compname, setcompname] = useState([]);
    const [co_code, setco_code] = useState([]);
    const { exchg, cocode, requestcompname } = useParams();
    const [exchange, setexchange] = useState(['NSE']);
    let getData;let getcompname;
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${requestcompname}`)
          .then((response) => response.json())
          .then((data) => {
            // console.log("comp data:" + JSON.stringify(data));
            setco_code(data.data[0]["co_code"]);
            setdataCompanyName(data.data);
            getcompname = data.data[0]["lname"];
            setexchange(data.data[0]["exchg"]);
            setcompname(getcompname);
            // console.log(getcompname)
            //setFandO(data.data[0]["symbol"]);
            // console.log(data)
          })
          .catch((error) => {
            //console.log("not found the api");
          });
      }, []);
    useEffect(() => {
        // getGetQuoteDetails(co_code, exchg);
        const getUrl = BaseURL + "keystats";
        if (getCoCode != "") {
            fetch(`${getUrl}/${getCoCode}/${type}`)
                .then((response) => response.json())
                .then((data) => {

                    setData(data.data);
                  
                })
                .catch((error) => {
                    //console.log("not found the api");
                });
        }

    
    }, [type, props.coCode]);

    const handleSelect = (key) => {
        if (key === "keyIndicatorsCons")
            settype('C');
        else
            settype('S');
    }
 

    return (
        <>
            <section className="company-fundamental-sectionKey">
                <Container className="add-border ">
                    <Row>
                        <Col md={12}>
                            <div className="table-boxkeystate">
                                {/* <h4>Key Stats : <span className="companyname">{compname}</span></h4> */}
                                 <div className="divcompanyname">
                                   <div className="companyname">{compname}</div>
                                   <div className="keystate">Key Stats</div>
                                 </div>
                                <Tabs
                                    defaultActiveKey="keyIndicatorsCons"
                                    transition={true}
                                    id="noanim-tab-example"
                                    className="mb-3" onSelect={(e) => handleSelect(e)}>
                                    <Tab eventKey="keyIndicatorsCons" title="Consolidated">
                                        <div>
                                            <ul className="key-list">
                                            {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                {data && data.map(({ mcap, PE, BV, Dividend_Per, EPS, Price_BookValue, Divyield, FaceValue, Marketlot, deliverables_per }) => (
                                                    <>
                                                        <li>
                                                            <span>Market Cap (₹ Cr)</span>
                                                            <h5>{(mcap != null) ? mcap.toFixed(2) : mcap = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>P/E Ratio</span>
                                                            <h5>{(PE != null) ? PE.toFixed(2) : PE = 0}</h5>
                                                        </li>

                                                        <li>
                                                            <span>EPS (TTM)</span>
                                                            <h5>{(EPS != null) ? EPS.toFixed(2) : EPS = 0}</h5>
                                                        </li>

                                                        <li>
                                                            <span>Dividend Yield (%)</span>
                                                            <h5>{(Divyield != null) ? Divyield.toFixed(2) : Divyield = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>Book Value</span>
                                                            <h5>{(BV != null) ? BV.toFixed(2) : BV = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>Price/Book</span>
                                                            <h5>{(Price_BookValue != null) ? Price_BookValue.toFixed(2) : Price_BookValue = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>Face Value</span>
                                                            <h5>{(FaceValue != null) ? FaceValue.toFixed(2) : FaceValue = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>Market Lot</span>
                                                            <h5>{(Marketlot != null) ? Marketlot.toFixed(2) : Marketlot = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>DIV (%)</span>
                                                            <h5>{(Dividend_Per != null) ? Dividend_Per.toFixed(2) : Dividend_Per = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>DELIVERABLES (%)</span>

                                                            <h5>{(deliverables_per != null) ? deliverables_per.toFixed(2) : '-'}</h5>

                                                        </li>
                                                    </>
                                                ))}

                                            </ul>
                                            {/* <p>
                                            Key indicators These are key financial factors that one
                                            should look at before investing in a stock. Use this
                                            information to run a fast check on the company's health
                                            and make informed investment decisions. P/E ratio
                                            (Price-to-earnings ratio) This helps you determine the
                                            market price of a stock as..
                                         </p> */}

                                        </div>
                                    </Tab>
                                    <Tab eventKey="keyIndicatorsStan" title="Standalone">
                                        <div>
                                            <ul className="key-list">
                                            {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                {data && data.map(({ mcap, PE, BV, Dividend_Per, EPS, Price_BookValue, Divyield, FaceValue, Marketlot, deliverables_per }) => (
                                                    <>
                                                        <li>
                                                            <span>Market Cap (₹ Cr)</span>
                                                            <h5>{(mcap != null) ? mcap.toFixed(2) : mcap = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>P/E Ratio</span>
                                                            <h5>{(PE != null) ? PE.toFixed(2) : PE = 0}</h5>
                                                        </li>

                                                        <li>
                                                            <span>EPS (TTM)</span>
                                                            <h5>{(EPS != null) ? EPS.toFixed(2) : EPS = 0}</h5>
                                                        </li>

                                                        <li>
                                                            <span>Dividend Yield (%)</span>
                                                            <h5>{(Divyield != null) ? Divyield.toFixed(2) : Divyield = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>Book Value</span>
                                                            <h5>{(BV != null) ? BV.toFixed(2) : BV = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>Price/Book</span>
                                                            <h5>{(Price_BookValue != null) ? Price_BookValue.toFixed(2) : Price_BookValue = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>Face Value</span>
                                                            <h5>{(FaceValue != null) ? FaceValue.toFixed(2) : FaceValue = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>Market Lot</span>
                                                            <h5>{(Marketlot != null) ? Marketlot.toFixed(2) : Marketlot = 0}</h5>
                                                        </li>
                                                        <li>
                                                            <span>DIV (%)</span>

                                                            <h5>{Dividend_Per.toFixed(2)}</h5>
                                                        </li>
                                                        <li>
                                                            <span>DELIVERABLES (%)</span>
                                                            <h5>{(deliverables_per != null) ? deliverables_per.toFixed(2) : '-'}</h5>

                                                        </li>
                                                    </>
                                                ))}

                                            </ul>
                                            {/* <p>
                                            Key indicators These are key financial factors that one
                                            should look at before investing in a stock. Use this
                                            information to run a fast check on the company's health
                                            and make informed investment decisions. P/E ratio
                                            (Price-to-earnings ratio) This helps you determine the
                                            market price of a stock as..
                                         </p> */}

                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                            <div className="loginsignupbtn_group main-div" >
                                {/* old buy button */}
                                {/* <button type="button" className="Login-Buttonkey end-0">
                                    <a href="https://online.moneysukh.com/">BUY</a>
                                </button> */}

                                 {/* buy button updated */}
                                <span className="Login-Buttonkey end-0 d-inline-block text-center">
                                    <a href="https://online.moneysukh.com/">BUY</a>
                                </span>

                                 {/* old sell button */}        
                                {/* <button type="button" className="Login-Buttonkey signup_btnkey end-0">
                                <a href="https://online.moneysukh.com/">SELL</a>
                                </button> */}

                                 {/* sell button updated */}
                                <span className="Login-Buttonkey signup_btnkey d-inline-block text-center end-0">
                                <a href="https://online.moneysukh.com/">SELL</a>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default CompanyKeystat;